/**
 * Ticker utilities: shortcode resolution, YouTube detection, etc.
 */

function toStr(v) { return (v?._id || v || '').toString(); }

/**
 * Resolve shortcodes like #h9 or #a12 to player names.
 * Uses already-loaded availablePlayers (Playertools) and game.
 *
 * #h9  → Heimteam, Trikotnummer 9
 * #a12 → Auswärtsteam, Trikotnummer 12
 *
 * Returns { textResolved, mentions[] }
 */
export function resolveShortcodes(text, game, availablePlayers) {
    if (!text || !game || !availablePlayers?.length) {
        return { textResolved: text || '', mentions: [] };
    }

    const homeId = toStr(game.hid?._id || game.hid);
    const awayId = toStr(game.aid?._id || game.aid);
    const mentions = [];

    const resolved = text.replace(/#([ha])(\d+)/gi, (match, side, numStr) => {
        const num = parseInt(numStr, 10);
        const teamId = side.toLowerCase() === 'h' ? homeId : awayId;
        const pt = availablePlayers.find(
            p => toStr(p.tid) === teamId && p.num === num
        );
        if (pt?.plid?.surname) {
            const name = pt.plid.prename
                ? `${pt.plid.prename[0]}. ${pt.plid.surname}`
                : pt.plid.surname;
            mentions.push({
                code: match,
                plid: toStr(pt.plid._id || pt.plid),
                name,
                teamSide: side.toLowerCase(),
            });
            return name;
        }
        return match; // unresolved codes stay as-is
    });

    return { textResolved: resolved, mentions };
}

/**
 * Extract YouTube video ID from various URL formats.
 * Supports: youtube.com/watch?v=, youtu.be/, youtube.com/shorts/
 */
export function extractYouTubeId(text) {
    if (!text) return null;
    const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    const match = text.match(regex);
    return match ? match[1] : null;
}

/**
 * Replace raw YouTube URLs in text with a placeholder so they don't show
 * twice (once as text, once as embed).
 */
export function stripYouTubeUrls(text) {
    if (!text) return text;
    return text
        .replace(/https?:\/\/(?:www\.)?youtube\.com\/watch\?v=[a-zA-Z0-9_-]{11}[^\s]*/g, '')
        .replace(/https?:\/\/youtu\.be\/[a-zA-Z0-9_-]{11}[^\s]*/g, '')
        .replace(/https?:\/\/(?:www\.)?youtube\.com\/shorts\/[a-zA-Z0-9_-]{11}[^\s]*/g, '')
        .trim();
}

/** Nachspiel: minute 0 und half 0 (nur nach Abpfiff gespeichert). */
export function isPostMatchEntry(event, gameFinished = false) {
    return gameFinished && !(event.minute) && event.half === 0;
}

/** Neueste Meldung oben — unabhängig von Spielminute. */
export function sortTickerEvents(events) {
    return [...events].sort((a, b) => {
        const t = new Date(b.createdAt) - new Date(a.createdAt);
        if (t !== 0) return t;
        return (b.minute || 0) - (a.minute || 0);
    });
}
